import { FC } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    headerSeparator: {
        height: '1px',
        background: tokens.colorNeutralStroke2,
        width: '100%',
        borderRadius: '1px',
        position: 'relative',
        zIndex: 3,
    },
    headerSeparatorWrapper: {
        width: '100%',
        marginBottom: '0px',
        position: 'relative',
        zIndex: 3,
    },
});

export const HorizontalSeparatorLine: FC = () => {
    const styles = useStyles();
    return (
        <div aria-hidden className={styles.headerSeparatorWrapper}>
            <div className={styles.headerSeparator} />
        </div>
    );
};